import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { BillingInformationContext } from "../../Account/BillingInformation/BillingInformationContext";
import { useCompany } from "../../Shared/components/CompanyProvider/CompanyProvider";
import { useCurrencyLocalizer } from "../../Shared/hooks/useCurrencyLocalizer";
import { CheckoutContext } from "../CheckoutContext";
export const useGiftCardCheckout = () => {
    const location = useLocation();
    const { primaryCreditCard, resetContext: resetBillingInfoContext, token, authorizeUrl, paymentIntentId, paymentProcessor, } = useContext(BillingInformationContext);
    const { resetContext: resetCheckoutContext } = useContext(CheckoutContext);
    const { mobileRedirectFailureUrl, mobileRedirectSuccessUrl, openedFromMobileApp } = useCompany();
    // const classes = useButtonStyles(buttonStyleProps);
    const giftCardState = location.state.giftCardState;
    const { localizedCurrencyText: giftCardCurrencyText } = useCurrencyLocalizer(giftCardState.amount);
    return {
        total: giftCardState.amount,
        giftCardCurrencyText,
        giftCardState,
        primaryCreditCard,
        // classes,
        token,
        authorizeUrl,
        paymentIntentId,
        paymentProcessor,
        mobileRedirectFailureUrl,
        mobileRedirectSuccessUrl,
        openedFromMobileApp,
        resetBillingInfoContext,
        resetCheckoutContext,
    };
};
